module.exports = __webpack_public_path__ + "static/media/alert.b5fb005e.png";